import Vue from 'vue'

import QMediaPlayer from '@quasar/quasar-ui-qmediaplayer/src/index'
import { boot } from 'quasar/wrappers'
import { sendBugsnagReport } from 'boot/bugsnag'
import { FUSIONAUTH_USER, TOKEN_NAME, TOKEN_REFRESH_NAME } from 'src/lib/constants'
import { fusionClient } from 'boot/fusionAuth'

Vue.use(QMediaPlayer)

async function loadData (store, router) {
  try {
    await store.dispatch('user/fusionAuthenticate')
  } catch (e) {
    if (e.statusCode === 423) {
      await router.push({ path: '/accountdisabled' }).catch(
        err => { if (err && err.name !== 'NavigationDuplicated') console.error(err) })
    } else console.error(e)
    throw e
  }
  await store.dispatch('lesson/upcomingLesson')
  const user = store.getters['user/getUser']

  await store.dispatch('local/getCurrentYear')
  await store.dispatch('local/fetchRoles')
  await store.dispatch('local/fetchLocations')
  await store.dispatch('local/fetchLevels')
  await store.dispatch('local/fetchSubjects')
  store.dispatch('local/getNotifications', user.id)
}

async function checkAuthentication (token, user, store, router) {
  const isValidToken = await fusionClient.validateJWT(token)
  try {
    const user = await fusionClient.retrieveUserUsingJWT(token)
    const currentUserEmail = user.response.user.email
    if (isValidToken.statusCode == 200) {
      try {
        await loadData(store, router)
        if (!user.response.user.active) {
          await router.push({
            path: '/accountdisabled'
          }).catch(err => { if (err && err.name !== 'NavigationDuplicated') console.error(err) })
        }
      } catch (e) {
        sendBugsnagReport(`${currentUserEmail}: ${e}`)
      }
    } else {
      router.push('/logout').catch(err => { if (err) console.error(err) })
    }
  } catch (e) {
    await router.push({
      path: '/notregistered',
      query: {
        email: user.email
      }
    }).catch(err => { if (err && err.name !== 'NavigationDuplicated') console.error(err) })
    sendBugsnagReport(`${user.email}: ${e}`)
    store.dispatch('user/logout')
  }
}
export default boot(async ({
  store,
  router
}): Promise<void> => {
  // retrieve data from localStorage
  const token = localStorage.getItem(TOKEN_NAME)
  const user = JSON.parse(localStorage.getItem(FUSIONAUTH_USER))
  const refreshToken = localStorage.getItem(TOKEN_REFRESH_NAME)

  if (token) {
    // if token exists, dispatch to validate
    let result = await store.dispatch('user/validateJWT', token)

    if (result.expired && refreshToken) {
      // execute only when the token verification expires and the refreshToken exists in localStorage
      result = await store.dispatch('user/retrieveNewAccessToken', {
        refreshToken,
        token
      })

      if (result.success) {
        // checkAuthentication when the results are success from retrieve new AccessToken
        await checkAuthentication(result.data, user, store, router)
      } else {
        // destroy data on localStorage and do force logout
        await store.dispatch('user/fusionAuthLogout')
        router.push('/logout').catch(err => { if (err) console.error(err) })
      }
    } else {
      // check authentication if token is not expired
      await checkAuthentication(token, user, store, router)
    }
  }
})
